module.exports = "<svg viewBox=\"0 0 12.9 17\"><path fill=\"#231F20\" d=\"M11.9 7.4c-.6 0-1-.4-1-1C10.9 4 8.9 2 6.4 2S2 4 2 6.4c0 .6-.4 1-1 1s-1-.4-1-1C0 2.9 2.9 0 6.4 0s6.4 2.9 6.4 6.4c.1.6-.4 1-.9 1z\"></path><circle cx=\"6.4\" cy=\"6.4\" r=\"1.8\" fill=\"#231F20\"></circle><path fill=\"#231F20\" d=\"M5.7 16.7l.7-.7-.7.7C2.8 13.8 0 11 0 6.4c0-.6.4-1 1-1s1 .4 1 1c0 3.7 2.4 6.1 5.1 8.8l-.7.8-.7.7z\"></path><path fill=\"#231F20\" d=\"M6.4 17c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4 2.7-2.7 5.1-5.1 5.1-8.8 0-.6.4-1 1-1s1 .4 1 1c0 4.6-2.8 7.3-5.7 10.2-.1.2-.4.3-.7.3z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/marker.svg
// module id = 308
// module chunks = 1